import React from "react";
import { GET } from "../../utils/AxiosRequest";

import Stack from "@mui/material/Stack";

import { DevisHeader } from "./DevisHeader/DevisHeader";
import { DevisBody } from "./DevisBody/DevisBody";
import { DevisButtons } from "./DevisButtons/DevisButtons";
import { Box } from "@mui/material";

import { useSearchParams } from "react-router-dom";

export const Devis = (props) => {
  const [saveOverride, setSaveOverride] = React.useState(false);
  const [logo, setLogo] = React.useState("inspiration");

  const headerRef = React.useRef(null);
  const bodyRef = React.useRef(null);
  const buttonsRef = React.useRef(null);

  const [queryParameters] = useSearchParams();

  function GetDevisFromDb(id) {
    return GET("factures/getDevisById", { id: id });
  }

  function handleLogoChange(value) {
    setLogo(value);
  }

  React.useEffect(() => {
    const devisId = queryParameters.get("id");
    if (devisId) {
      GetDevisFromDb(devisId).then((data) => {
        LoadDevis(data[0], true);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function UpdateTotal(total) {
    headerRef.current.updateTotal(total);
  }

  function updateAccompte(data) {
    headerRef.current.updateDueDatesData(data);
  }

  function UpdateSaveButton() {
    buttonsRef.current.canSave(CheckSaveEnabled());
  }

  function UpdateClient(client) {
    return GET("devis/getCLientInfo", { clientId: client.id }).then((data) => {
      headerRef.current.updateClient(data[0]);
      buttonsRef.current.canSave(CheckSaveEnabled());
    });
  }

  function LoadDevis(devis, isDevis) {
    buttonsRef.current.canSave(false);
    var promises = [GET("devis/getDevisById", { id: devis.id })];

    if (devis.idClient) {
      promises.push(GET("devis/getCLientInfo", { clientId: devis.idClient }));
    }
    setSaveOverride(isDevis);

    return Promise.all(promises).then((data) => {
      bodyRef.current.loadDevis(data[0][0].devisData);
      if (isDevis) {
        headerRef.current.updateDevisInfo(data[0][0]);
      } else {
        headerRef.current.clearDevisInfo();
        headerRef.current.assignNewDevisId();
      }

      if (data[1]) {
        headerRef.current.updateClient(data[1][0]);
      }
      headerRef.current.updateDueDatesInfo(data[0][0]);
      headerRef.current.updateTotal(bodyRef.current.getTotal());
      UpdateSaveButton();
    });
  }

  function AddPremadeLines(lines) {
    bodyRef.current.addPremadeLines(lines);
    UpdateSaveButton();
  }

  function AddSpecialLine(type) {
    bodyRef.current.addSpecialLine(type);
    UpdateSaveButton();
  }

  function GetDataForPDF() {
    if (!headerRef.current) return null;
    var header = headerRef.current.getHeaderData();
    var body = bodyRef.current.getBodyData();
    var total = bodyRef.current.getTotal();
    return {
      header,
      body,
      total,
      save: saveOverride,
      logo: logo,
    };
  }

  function CheckSaveEnabled() {
    if (headerRef.current === null || bodyRef.current === null) return false;
    return (
      headerRef.current.isClientSelected() && !bodyRef.current.isBodyEmpty()
    );
  }

  function ReloadTarifs() {
    bodyRef.current.reloadTarifs();
  }
  //#endregion

  return (
    <Box width="100%" height="100%">
      <Stack
        width="100%"
        paddingBottom={10}
        direction="row"
        justifyContent="space-between"
        overflow={"auto"}
      >
        <DevisHeader ref={headerRef} />
        <Stack direction="row" justifyContent="space-around" width="100%">
          <DevisBody
            ref={bodyRef}
            updateTotal={UpdateTotal}
            checkSaveEnabled={UpdateSaveButton}
          />
          <DevisButtons
            ref={buttonsRef}
            reloadTarifs={ReloadTarifs}
            updateClient={UpdateClient}
            updateAccompte={updateAccompte}
            loadDevis={LoadDevis}
            setSaveOverride={setSaveOverride}
            addPremadeLines={AddPremadeLines}
            addSpecialLine={AddSpecialLine}
            getDataForPDF={GetDataForPDF}
            checkSaveEnabled={CheckSaveEnabled}
            selectedLogo={logo}
            onLogoChange={handleLogoChange}
          />
        </Stack>
      </Stack>
    </Box>
  );
};
